import React from 'react';

import { Grid } from 'common/components/Grid';
import type { PictureTextKind } from '../enums';
import type { PictureTextItemProps } from './PictureTextItem';
import PictureTextItem from './PictureTextItem';

export interface PictureTextProps {
  kind: PictureTextKind;
  items: Array<Omit<PictureTextItemProps, 'kind'>>;
}

const PictureText = ({ kind, items }: PictureTextProps) => (
  <Grid data-corgi-id="picture-text">
    {items.map((item, index) => (
      <PictureTextItem key={index} kind={kind} {...item} />
    ))}
  </Grid>
);

export default PictureText;
